export default __webpack_public_path__ + "static/media/earphones6.3b93e924.jfif";